import _taggedTemplateLiteralLoose from '@babel/runtime/helpers/esm/taggedTemplateLiteralLoose';
import _extends from '@babel/runtime/helpers/esm/extends';
import React, { useContext, forwardRef, cloneElement } from 'react';
import styled, { ThemeContext, css, ThemeProvider } from '@xstyled/styled-components';
import toast from 'toasted-notes';
import { system, filterComponent } from '@trybeapp/ui.system';
import { ClearButton } from '@trybeapp/ui.clear-button';
import { Box } from '@trybeapp/ui.box';
import { getVariantColor } from '@trybeapp/ui.utilities';
import 'prop-types';
import { th } from '@xstyled/system';

var _templateObject, _templateObject2, _templateObject3;
function useToast() {
  var themeContext = useContext(ThemeContext);
  var createToast = function createToast(children, options) {
    var toastOptions = _extends({
      position: 'bottom',
      duration: 3000
    }, options);
    var isBottomPosition = toastOptions.position.startsWith('bottom');
    if (children) {
      toast.notify(function (_ref) {
        var onClose = _ref.onClose;
        return /*#__PURE__*/React.createElement(ThemeProvider, {
          theme: themeContext
        }, /*#__PURE__*/React.createElement(StyledToastContainer, {
          isBottom: isBottomPosition
        }, cloneElement(children, _extends({}, children.props, {
          onClose: onClose
        }))));
      }, _extends({}, toastOptions));
    }
  };
  return createToast;
}
var StyledToast = /*#__PURE__*/styled.div(function (_ref2) {
  var variant = _ref2.variant;
  return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  position: relative;\n  max-width: 25rem;\n  padding: lg;\n  ", ";\n  background-color: ", ";\n  ", ";\n"])), th('toasts.growls.default'), getVariantColor(variant), system);
});
var Toast = /*#__PURE__*/forwardRef(function (_ref3, ref) {
  var children = _ref3.children,
    onClose = _ref3.onClose,
    _ref3$variant = _ref3.variant,
    variant = _ref3$variant === void 0 ? 'info' : _ref3$variant;
  return /*#__PURE__*/React.createElement(StyledToast, {
    ref: ref,
    variant: variant
  }, onClose && /*#__PURE__*/React.createElement(ClearButton, {
    onClick: onClose,
    position: "absolute",
    right: 10,
    size: "sm",
    color: "light.900",
    top: 10
  }), children);
});
var StyledToastContainer = /*#__PURE__*/styled(filterComponent(Box, ['isBottom']))(function (_ref4) {
  var isBottom = _ref4.isBottom;
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n    ", "\n    ", "\n  "])), th('toasts.default'), isBottom ? th('toasts.bottom') : th('toasts.top'));
});
var StyledTitle = /*#__PURE__*/styled.div(function () {
  return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n    display: flex;\n    align-items: center;\n    color: light.900;\n    padding-bottom: md;\n    ", ";\n\n    & > *:first-child {\n      flex-shrink: 0;\n      margin-right: sm;\n    }\n  "])), th('toasts.growls.title'));
});
var Title = function Title(_ref5) {
  var children = _ref5.children,
    _ref5$variant = _ref5.variant,
    variant = _ref5$variant === void 0 ? 'info' : _ref5$variant;
  return /*#__PURE__*/React.createElement(StyledTitle, {
    variant: variant
  }, children);
};
Toast.displayName = 'Toast';
Toast.Title = Title;

export { StyledToast, Title, Toast, useToast };
